import React, { useEffect, useState } from "react";
import { formatDate } from "../../../components/reusableComponent/DateFormat";
import { useLocation } from "react-router-dom";
import ReactModal from "react-modal";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import RescheduleAppointment from "./RescheduleAppointment";
import CancelAppointment from "./CancelAppointment";
import useThemeColors from "../../vehicle/ThemeColors";
import { useConfirmAppointmentMutation } from "../../../Services/inventory/Inventory";
import ConfirmationModal from "./ConfirmationModal";
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";

const GetAppintmentDetails = () => {
  const location = useLocation();
  const [getLocationData, setGetLocationData] = useState<any>({});
  const [openRescheduleModal, setOpenRescheduleModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  useEffect(() => {
    if (location) {
      setGetLocationData(location?.state);
    }
  }, [location]);

  console.log(
    getLocationData?.booking_request,
    "getLocationDatagetLocationData"
  );

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse" as const,
    border: "1px solid #ccc",
    fontWeight: 200,
  };

  const cellStyle = {
    padding: "10px",
    border: "1px solid #ccc",
  };

  const rawAddress = getLocationData?.workshop_details?.address || "";
  const addressParts = rawAddress.split(",").map((part) => part.trim());

  // Defensive defaults
  let pinCode = "";
  let state = "";
  let city = "";
  let addressLine = "";

  if (addressParts?.length >= 3) {
    const stateAndPin = addressParts[addressParts?.length - 2]; // e.g. "Uttar Pradesh 201301"
    pinCode = stateAndPin.match(/\d{6}/)?.[0] || "";
    state = stateAndPin.replace(pinCode, "").trim();
    city = addressParts[addressParts?.length - 3];
    addressLine = addressParts.slice(0, addressParts?.length - 3).join(", ");
  }

  console.log(getLocationData, "getLocationData");

  const closeModal = () => {
    setOpenRescheduleModal(false);
    setOpenCancelModal(false);
    setOpenConfirmModal(false);
  };

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();

  const customModalStyles1: ReactModal.Styles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-40%, -50%)",
      width: "30%",
      border: "none",
      boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
      borderRadius: "40px",
      padding: "5px",
    },
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
    paddingBottom: "0",
  };

  const completeHandler = async () => {
    setOpenConfirmModal(true);
  };

  console.log(getLocationData, "getLocationData");

  return (
    <div style={{ padding: "20px", fontFamily: "karbon" }}>
      <h3 style={{ fontWeight: 200 }}>
        {/* Appointment Details # */}
        {getLocationData?.appointment_id}
      </h3>

      {/* Workshop Info */}
      {/* Customer Information */}
      <h4 style={{ fontWeight: 200 }}>Customer Information</h4>
      <table style={tableStyle}>
        <tbody>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Customer Name</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.customer_details?.first_name} {getLocationData?.customer_details?.last_name}
            </td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Email</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.email}</td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Phone</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.customer_details?.phone}
            </td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Address</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.customer_details?.address}
            </td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>City</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.city}</td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>State</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.state}</td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Pincode</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.customer_details?.pincode}
            </td>
            
          </tr>
        </tbody>
      </table>

{/* Vehicle Info */}
      <h4 style={{ marginTop: "30px", fontWeight: 200 }}>
        Vehicle Information
      </h4>
      <table style={tableStyle}>
        <tbody>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Car Make</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.vehicle_details?.brand_name}
            </td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Model</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.vehicle_details?.model_name}
            </td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Fuel</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.vehicle_details?.fuel_type}
            </td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>
                Vehicle Registration Number
              </strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.vehicle_details?.vehicle_number}
            </td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Service Type</strong>
            </td>
            <td
              style={cellStyle}
              title={getLocationData?.booking_request?.service_details
                ?.map((srv) => srv?.name)
                .join(", ")}
            >
              {getLocationData?.booking_request?.service_details
                ?.map((srv) => srv?.name)
                .join(", ")}
            </td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Appointment Date</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.appointment_date
                ? (() => {
                    const dateStr = getLocationData.appointment_date;
                    if (!dateStr) return 'N/A';

                    const parts = dateStr.split('T');
                    if (parts.length < 2) return 'Invalid date format';

                    const [datePart, timePart] = parts;
                    const dateParts = datePart?.split('-') || [];
                    if (dateParts.length < 3) return 'Invalid date format';

                    const [year, month, day] = dateParts;
                    const timeComponents = (timePart?.split('.')[0] || '').split(':');
                    if (timeComponents.length < 2) return 'Invalid time format';

                    const [hours, minutes] = timeComponents;
                    const hoursNum = parseInt(hours, 10) || 0;

                    // Convert to 12-hour format
                    let hour12 = hoursNum % 12;
                    hour12 = hour12 === 0 ? 12 : hour12;
                    const period = hoursNum >= 12 ? 'PM' : 'AM';

                    return `${day}/${month}/${year}, ${hour12.toString().padStart(2, '0')}:${minutes} ${period}`;
                  })()
                : ""}
            </td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Service Details</strong>
            </td>
            <td
              style={cellStyle}
              colSpan={3}
              title={getLocationData?.booking_request?.service_details
                ?.flatMap((srv) => srv.sub_services?.map((sub) => sub?.name))
                .join(", ")}
            >
              {getLocationData?.booking_request?.service_details
                ?.flatMap((srv) => srv.sub_services?.map((sub) => sub?.name))
                .join(", ")}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Action Buttons */}
      {getLocationData?.status !== "cancelled" &&
        getLocationData?.status !== "completed" && (
          <div style={{ marginTop: "30px", display: "flex", gap: "10px" }}>
            {/* Always allow reschedule */}
            <button
              onClick={() => setOpenRescheduleModal(true)}
              style={{
                backgroundColor: "#00bcd4",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "5px",
                border: "none",
              }}
            >
              Reschedule
            </button>

            {/* Accept only if not already accepted */}
            {getLocationData?.status !== "accepted" && (
              <button
                onClick={completeHandler}
                style={{
                  background: `${selectedButtonBackgoundColors}`,
                  color: `${selectedButtonColors}`,

                  padding: "10px 20px",
                  borderRadius: "5px",
                  border: "none",
                }}
              >
                Complete
              </button>
            )}

            {/* Always allow cancel */}
            {/* <button
              onClick={() => setOpenCancelModal(true)}
              style={{
                backgroundColor: "#f44336",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "5px",
                border: "none",
              }}
            >
              Cancel
            </button> */}
          </div>
        )}

      {/* History Table */}
      <h4 style={{ marginTop: "40px", fontWeight: 200 }}>
        Appointment History
      </h4>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th
              style={{ textAlign: "center", padding: "10px", fontWeight: 200 }}
            >
              Scheduled Dates
            </th>
            <th
              style={{ textAlign: "center", padding: "10px", fontWeight: 200 }}
            >
              Status Updated
            </th>
            <th
              style={{ textAlign: "center", padding: "10px", fontWeight: 200 }}
            >
              Reason
            </th>
            <th
              style={{ textAlign: "center", padding: "10px", fontWeight: 200 }}
            >
              Updated By
            </th>
            <th
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "10px",
                fontWeight: 200,
              }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {getLocationData?.logs?.map((el, ind) => (
            <tr
              style={{
                background: ind % 2 === 0 ? "#d2d0d0" : "white",
                color: "black",
                padding: "10px",
                width: "100%",
                fontWeight: 200,
              }}
            >
              <td
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "10px",
                }}
              >
                {el.created_at === null ? "-" : formatDate(el?.created_at)}
              </td>
              <td
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "10px",
                }}
              >
                {el?.new_status}
              </td>
              <td style={{ padding: "10px", textAlign: "center" }}>
                <div
                  style={{
                    width: "150px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "#888",
                    margin: "0 auto", // to center it inside the cell
                  }}
                  data-toggle="tooltip"
                  data-placement="top"
                  title={el?.notes}
                >
                  {el?.notes}
                </div>
              </td>{" "}
              <td
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "10px",
                }}
              >
                {el?.user_type}
              </td>
              <td
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "10px",
                }}
              >
                {el?.action}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal
        open={openRescheduleModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }} // Ensure it's above the modal content
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
              fontFamily: "Karbon-regular",
              fontSize: "20px",
            }}
          >
            Reschedule Appointment
          </Typography>

          <Box>
            <RescheduleAppointment
              closeModal={closeModal}
              // refetch={refetch}
              storeValue={getLocationData}
            />
          </Box>
        </Box>
      </Modal>

      <ReactModal
        isOpen={openCancelModal}
        onRequestClose={closeModal}
        style={customModalStyles1}
      >
        <CancelAppointment
          storedWorkshopData={getLocationData}
          closeModal={closeModal}
          // refetch={refetch}
        />
      </ReactModal>

      <ReactModal
        isOpen={openConfirmModal}
        onRequestClose={closeModal}
        style={customModalStyles1}
      >
        <ConfirmationModal
          storedWorkshopData={getLocationData}
          closeModal={closeModal}
          // refetch={refetch}
        />
      </ReactModal>
    </div>
  );
};

export default GetAppintmentDetails;
